export default function createConverter(EntityClass) {
  return {
    fromDto(...args) {
      return EntityClass.fromJs(...args);
    },

    toDto(entity) {
      return entity.toJs();
    },
  };
}



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/lib/create_converter.js